/**
 * Webpage for drawing the model-Polygons
 */
import React, {Component, createRef} from "react";
import L from "leaflet";
import {Button,} from "react-bootstrap";
import {v4 as uuidv4} from 'uuid';
import {featureCollection, intersect} from "@turf/turf"
import {Toast} from 'primereact/toast';
import {Dropdown} from 'primereact/dropdown';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrashAlt} from "@fortawesome/free-regular-svg-icons";
import {faPen} from "@fortawesome/free-solid-svg-icons";
import {Dialog} from "primereact/dialog";
import {cloneDeep} from "lodash";

class OutdoorTrafficModelSubmission extends Component {
    constructor(props) {
        super(props);
        let uuid = uuidv4();
        this.props.setUuid(uuid)
        this.json = JSON.parse(localStorage.getItem("json"));
        this.buildings = JSON.parse(localStorage.getItem("buildings"));
        this.customAntennas = JSON.parse(localStorage.getItem("customAntennas"));
        this.drawnItems = new L.featureGroup();
        this.buildingLayer = new L.featureGroup();
        this.state = {
            appSelect: 0,
            btnDisable: false,
            priorityDialog: false,
            baseDialog: false,
            datarateDownLink: 100,
            datarateUpLink: 50,
            currentID: 0,
            currentApp: {
                title: "",
                apps: [],
                datarate: 0,
                direction: "Uplink"
            }
        }
        this.userChanged = this.userChanged.bind(this)
        this.onAppsChange = this.onAppsChange.bind(this)
        this.onDirChange = this.onDirChange.bind(this)
        this.onNumChange = this.onNumChange.bind(this)
        this.onAddClick = this.onAddClick.bind(this)
        this.deleteRow = this.deleteRow.bind(this)
        this.deletePriority = this.deletePriority.bind(this)
        this.onNameChange = this.onNameChange.bind(this)
        this.buildingSelect = this.buildingSelect.bind(this)
        this.safeCurrentApp = this.safeCurrentApp.bind(this)
        this.editPriority = this.editPriority.bind(this)
        this.datarateChange = this.datarateChange.bind(this)
        this.deleteBase = this.deleteBase.bind(this)
        this.editBase = this.editBase.bind(this)
        this.checkNext = this.checkNext.bind(this)
        this.direction = [{
            "value": "Uplink",
            "label": "Uplink"
        },
            {
                "value": "Downlink",
                "label": "Downlink"
            }
        ]
        this.apps = [{
            "value": 0,
            "name": "Video HD (10 MBit/s)",
            "datarate": 10
        },
            {
                "value": 1,
                "name": "Video UHD (40 MBit/s)",
                "datarate": 40
            },
            {
                "value": 2,
                "name": "Video 360° (80 MBit/s)",
                "datarate": 80
            },
            {
                "value": 3,
                "name": "Echtzeitaudio Comms  (1 MBit/s)",
                "datarate": 1
            },
            {
                "value": 4,
                "name": "Echtzeitaudio HD (4 MBit/s)",
                "datarate": 4
            },
        ]
        this.maxDataRate = 1000
        this.toast = createRef()
    }

    /**
     * Same as useEffect
     */
    componentDidMount() {
        //setting up map
        var map = L.map('map', {
            zoom: 0,
        });
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            minZoom: 6,
            maxNativeZoom: 18,
            maxZoom: 20,
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        }).addTo(map);
        var drawControl = new L.Control.Draw({
            draw: false,
            edit: {
                edit: false,
                remove: false,
                featureGroup: this.drawnItems,
            },
            tooltip: {'className': 'polygon-tooltip'},
        });
        // this.checkNext()
        map.addControl(drawControl);
        this.polygon = L.polygon(JSON.parse(localStorage.getItem("polygon")), {
            color: 'red',
            fill: false
        }).addTo(this.drawnItems);
        if (this.buildings !== null) {
            this.buildings.forEach((building, index) => {
                let poly = L.polygon(building.polygon, {
                    color: 'grey',
                    fill: true,
                }).bindTooltip("Höhe: " + building.height+"m").addTo(this.buildingLayer)
                poly.index = index;
                poly.setStyle({
                    color: this.buildings[index].selected ? "red" : "grey"
                });
            })
        }
        if (this.customAntennas !== null) {
            this.customAntennas.forEach((antenna, index) => {
                let marker = L.marker(antenna.coords);
                marker.bindTooltip(antenna.name).addTo(this.drawnItems)
            })
        }
        map.addLayer(this.buildingLayer)
        if (this.json["priorities"] !== undefined) {
            this.json["priorities"].forEach((priority) => {
                let p = L.polygon(priority["polygon"], {
                    color: "#f0ffff",
                    fill: true,
                    fillOpacity: 0.7
                }).addTo(this.drawnItems)
                p.bindTooltip(priority["title"], {
                    permanent: true,
                    className: 'polygon-tooltip'
                });
                priority.id = L.stamp(p)
            })
        }
        map.addLayer(this.drawnItems)
        map.fitBounds(this.polygon.getBounds())
        map.on(L.Draw.Event.CREATED, (e) => {
            this.drawingCreated(e)
        })
        this.map = map
        this.setState({datarateUpLink: this.json.datarateUpLink, datarateDownLink: this.json.datarateDownLink},
            () => {
                if (parseFloat(this.state.datarateDownLink) + parseFloat(this.state.datarateUpLink) > 0)
                    document.getElementById("basis").style.display = "table-row"
                this.userChanged()
            })
        this.props.setJson(this.json)
    }

    onNameChange(e) {
        let temp = {...this.state.currentApp}
        temp.title = e.target.value
        this.setState({currentApp: temp})
    }

    safeCurrentApp() {
        this.json.priorities[this.state.currentID] = this.state.currentApp
        this.props.setJson(this.json)
        // this.checkNext()
    }

    /**
     * save and display Polygon
     */
    drawingCreated(e) {
        var coords;
        var type = e.layerType,
            drawLayer = e.layer;
        if (type === 'polygon') {
            // try {
            const flipped = intersect(featureCollection([this.polygon.toGeoJSON(), drawLayer.toGeoJSON()])).geometry.coordinates
            coords = flipped[0].map((i) => [i[1], i[0]])
            let layer = L.polygon(coords, {color: "#f0ffff", fill: true, fillOpacity: 0.7})
            this.drawnItems.addLayer(layer);
            this.map.fitBounds(layer.getBounds())
            let btn = document.getElementById("addBtn")
            btn.disabled = false
            const curr = {
                id: L.stamp(layer),
                polygon: layer.getLatLngs()[0],
                title: "Anwendungsbereich " + (this.json["priorities"] !== undefined ? this.json["priorities"].length + 1 : 1),
                apps: [],
                datarate: 0,
                direction: "Uplink"
            }
            layer.bindTooltip(curr["title"], {
                permanent: true,
                className: 'polygon-tooltip'
            });
            this.setState({currentApp: curr})
            this.setState({currentID: this.json["priorities"].length})
            this.setState({priorityDialog: true})
            // } catch (e) {
            //     this.toast.current.show({
            //         life: 5000,
            //         severity: 'error',
            //         summary: 'Fehler',
            //         detail: 'Die Gebiete dürfen sich nicht selbst überschneiden, bitte erneut erstellen'
            //     });
            //     document.getElementById("addBtn").disabled = false
            // }
        }

    }

    /**
     * onChange of the model-user
     */

    onDirChange(e) {
        let temp = {...this.state.currentApp}
        temp.direction = e.value
        this.setState({currentApp: temp},
            this.userChanged);
    }

    buildingSelect(e) {
        this.buildingLayer.getLayer()
        this.buildings[e.target.index].selected = !this.buildings[e.target.index].selected
        let poly = this.buildingLayer.getLayers()[e.target.index]
        poly.setStyle({
            color: this.buildings[e.target.index].selected ? "red" : "grey"
        });
    }

    onNumChange(e) {
        const newVal = this.state.currentApp.datarate + parseInt(document.getElementById("num").value) * this.apps[this.state.appSelect].datarate
        if (newVal <= this.maxDataRate) {
            this.setState({btnDisable: false})
        } else {
            this.setState({btnDisable: true})
        }
    }

    onAppsChange(e) {
        this.setState({appSelect: e.value},
            this.onNumChange
        )
    }

    onAddClick(e) {
        let temp = {...this.state.currentApp}
        const newVal = (temp.apps.length !== 0 ? this.state.currentApp.datarate : 0) + parseInt(document.getElementById("num").value) * this.apps[this.state.appSelect].datarate
        let app = {...this.apps[this.state.appSelect]}
        app.num = parseInt(document.getElementById("num").value)
        temp.apps.push(app)
        temp.datarate = newVal
        this.setState({currentApp: temp}, () => {
            this.userChanged(e)
            this.onNumChange(e)
        })
        if (newVal + (parseInt(document.getElementById("num").value) * this.apps[this.state.appSelect].datarate) > this.maxDataRate) {
            this.setState({btnDisable: true})
        } else
            this.setState({btnDisable: false})
    }

    userChanged(e) {
        let temp = {...this.state.currentApp}
        if (this.state.priorityDialog) {
            if (document.getElementById("datarate").value > this.maxDataRate)
                temp.datarate = this.maxDataRate
            else if (document.getElementById("datarate").value < 0)
                temp.datarate = "0"

            this.setState({currentApp: temp})
        }
        // this.checkNext()
    }

    /**
     * draw start function
     */
    drawStart(e) {
        var drawPolygon = new L.Draw.Polygon(this.map);
        drawPolygon.setOptions({shapeOptions: {color: "#f0ffff", fill: true, fillOpacity: 0.7}});
        drawPolygon.enable();
        document.getElementById("addBtn").disabled = true
    }

    deleteRow(e) {
        let temp = {...this.state.currentApp}
        var i;
        if (e.target.tagName === "path") {
            i = e.target.parentNode.getAttribute("index")
        } else {
            i = e.target.getAttribute("index")
        }
        temp.datarate = temp.apps.length > 0 ? this.state.currentApp.datarate - temp.apps[i].datarate * temp.apps[i].num : 0
        temp.apps.splice(i, 1)
        this.setState({currentApp: temp})
        if (this.state.currentApp.datarate <= this.maxDataRate) {
            this.setState({btnDisable: false})
        } else {
            this.setState({btnDisable: true})
        }
    }

    deletePriority(e) {
        var i;
        if (e.target.tagName === "path") {
            i = e.target.parentNode.getAttribute("index")
        } else {
            i = e.target.getAttribute("index")
        }
        this.drawnItems.removeLayer(this.json.priorities[i].id)
        this.json.priorities.splice(i, 1)
        this.props.setJson(this.json)
        this.setState({priorityDialog: false})
        //this.checkNext()
    }

    checkNext() {
        const next = document.getElementById('next')
        if ((this.state.datarateUpLink !== 0 && this.state.datarateDownLink !== 0) || this.json.priorities.length > 0) {
            next.classList.add('hover');
            next.classList.remove('fa-disabled');
            next.style.pointerEvents = "auto";
        } else {
            next.classList.remove('hover');
            next.classList.add('fa-disabled');
            next.style.pointerEvents = "none";
        }
    }

    editPriority(e) {
        var i;
        if (e.target.tagName === "path") {
            i = e.target.parentNode.getAttribute("index")
        } else {
            i = e.target.getAttribute("index")
        }

        this.setState({priorityDialog: true, currentID: i, currentApp: cloneDeep(this.json.priorities[i])})
    }

    deleteBase(e) {
        this.setState({datarateUpLink: 0, datarateDownLink: 0}, this.datarateChange)
    }

    editBase(e) {
        this.setState({baseDialog: true})
    }

    datarateChange() {
        this.json.datarateUpLink = parseFloat(this.state.datarateUpLink)
        this.json.datarateDownLink = parseFloat(this.state.datarateDownLink)
        if (this.json.datarateDownLink + this.json.datarateUpLink > 0)
            document.getElementById("basis").style.display = "table-row"
        else
            document.getElementById("basis").style.display = "none"

        this.userChanged()
        this.props.setJson(this.json)
    }

    render() {
        return (
            <div>
                <div id={"map"}/>
                <div className={'text-center'}
                     style={{pointerEvents: "none", marginTop: '-140px', position: 'relative', zIndex: '1'}}>
                    <div className={'my-5 px-3 py-1 d-inline-block bg-secondary text-white rounded-3'}
                         style={{pointerEvents: "auto"}}>
                        <div className='fs-4'>Bitte definieren Sie oben rechts die Anforderungen Ihrer Anwendung.</div>
                    </div>
                </div>
                <div className="OverlaySettings shadow-lg  px-3 pt-2" //container-fluid p-3"
                     style={{maxWidth: "560px", maxHeight: "600px", overflow: "auto"}}>
                    <table className="table mb-0 caption-top customTable">
                        <caption className="text-dark fw-bold text-xl text-center">Anforderungen der Anwendung</caption>
                        <tbody>
                        <tr style={{border: "white"}}>
                            <th className="align-middle">
                                Basisversorgung:
                            </th>
                            <td className="text-right">
                                <Button
                                    disabled={0}//parseFloat(this.state.datarateUpLink) + parseFloat(this.state.datarateDownLink) > 0}
                                    onClick={(e) => {
                                        this.setState({
                                            baseDialog: true, datarateUpLink: parseFloat(this.state.datarateUpLink) <= 0 ? 50 : parseFloat(this.state.datarateUpLink),
                                            datarateDownLink: parseFloat(this.state.datarateDownLink) <= 0 ? 100 : parseFloat(this.state.datarateDownLink)
                                        })
                                    }} variant="outline-dark btn-dark" id="baseBtn" style={{
                                    color: "white",
                                    border: "1px solid #ced4da",
                                    width: "10rem"
                                }}><span>{parseFloat(this.state.datarateUpLink) + parseFloat(this.state.datarateDownLink) <= 0 ? "Hinzufügen" : "Ändern"}</span></Button>
                            </td>
                        </tr>
                        <tr style={{border: "white"}}>
                            <th className="align-middle">
                                Anwendungsbereich eingrenzen:
                            </th>
                            <td className="text-right">
                                <Button disabled={false} onClick={(e) => {
                                    this.drawStart(e)
                                }} variant="outline-dark btn-dark" id="addBtn" style={{
                                    color: "white",
                                    border: "1px solid #ced4da",
                                    width: "10rem"
                                }}><span>Eingrenzen</span></Button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <div className="overflow-auto"> {/*"col-12"> */}
                        <div className={"d-flex"}>
                        {/* <span className={"m-auto text-center text-xs"}> */}
                            {/* (Ohne explizite Anforderungsdefinition wird das Standard Planungsziel verwendet: */}
                            {/* <br/>100 MBit/s im Downlink und 50 MBit/s im Uplink) */}
                        {/* </span> */}
                        </div>
                        <table className="table">
                            <thead style={{
                                background: "white",
                                position: "sticky",
                                top: "0",
                                zIndex: "1",
                                borderBottom: "1px solid black"
                            }}>
                            <tr>
                                <th style={{fontSize: "small"}}>Anwendung</th>
                                <th style={{fontSize: "small"}}>Datenrate [MBit/s]</th>
                                <th style={{fontSize: "small"}}>Übertragungsrichtung</th>
                                <th/>
                                <th/>
                            </tr>
                            </thead>
                            <tbody>
                            <tr id={"basis"} style={{display: "none"}}>
                                <td style={{fontSize: "small"}}>Basisversorgung</td>
                                <td style={{fontSize: "small"}}>{this.state.datarateUpLink + ", " + this.state.datarateDownLink}</td>
                                <td style={{fontSize: "small"}}>Uplink, Downlink</td>
                                <td><FontAwesomeIcon onClick={this.editBase}
                                                     className={'hover align-middle'}
                                                     icon={faPen} size={"1x"} id={'edit_base'}/>
                                </td>
                                <td><FontAwesomeIcon onClick={this.deleteBase}
                                                     className={'hover align-middle'}
                                                     icon={faTrashAlt} size={"1x"} id={'delete_base'}/>
                                </td>
                            </tr>
                            {this.json.priorities.map(function (row, i) {
                                    return (
                                        <tr key={i}>
                                            <td style={{fontSize: "small"}}>{row.title}</td>
                                            <td style={{fontSize: "small"}}>{row.datarate}</td>
                                            <td style={{fontSize: "small"}}>{row.direction}</td>
                                            <td><FontAwesomeIcon index={i} onClick={this.editPriority}
                                                                 className={'hover align-middle'}
                                                                 icon={faPen} size={"1x"} id={'edit_' + i}/>
                                            </td>
                                            <td><FontAwesomeIcon index={i} onClick={this.deletePriority}
                                                                 className={'hover align-middle'}
                                                                 icon={faTrashAlt} size={"1x"} id={'delete_' + i}/>
                                            </td>

                                        </tr>
                                    );
                                }.bind(this)
                            )}
                            </tbody>
                        </table>
                    </div>
                    <p className="pl-2" style={{fontSize: "x-small", display: "none"}}>Falls Sie den <b>Anwendungsbereich
                        eingrenzen</b>, wird die definierte Anforderung <b>nur in diesem Bereich</b> realisiert. Dies
                        erhöht die maximal erreichbare Abdeckung mit der gewünschten Anforderung. Falls sie <b>keine
                            Eingrenzung</b> definieren, wird für den <b>gesamten Campusnetzbereich</b> geplant.</p>
                </div>
                <Toast ref={this.toast}/>
                <Dialog pt={{
                    closeButton: {
                        style: {display: "none"}
                    }
                }} header={
                    <div className="inline-flex align-items-center justify-content-center gap-2">
                        <span className="font-bold white-space-nowrap">Name: </span>
                        <input onChange={this.onNameChange}
                               value={this.state.currentApp.title}/>
                    </div>
                } footer={
                    <div>
                        <Button className={"me-3"} label="Speichern" icon="pi pi-check" onClick={() => {
                            this.safeCurrentApp()
                            this.setState({priorityDialog: false})
                        }} disabled={this.state.currentApp.datarate === 0}>Speichern</Button>
                        <Button label="Abbrechen" icon="pi" onClick={() => {
                            this.setState({priorityDialog: false})
                            if (this.json.priorities[this.state.currentID] === undefined) {
                                this.drawnItems.removeLayer(this.state.currentApp.id)
                            }
                        }}>Abbrechen</Button>
                    </div>
                } visible={this.state.priorityDialog} style={{width: '50vw'}} onHide={() => {
                    this.setState({priorityDialog: false})
                }}>
                    <div className={"row"}>
                        <div className={"col-6 p-0 tableFixHead "}>
                            <table className={"table"}>
                                <thead>
                                <tr>
                                    <th style={{fontSize: "small"}}>Anwendung</th>
                                    <th style={{fontSize: "small"}}>Anzahl</th>
                                    <th/>
                                </tr>
                                </thead>
                                <tbody>
                                {this.state.currentApp.apps.map(function (row, i) {
                                        return (
                                            <tr key={i}>
                                                <td style={{fontSize: "small"}}>{row.name}</td>
                                                <td style={{fontSize: "small"}}>{row.num}</td>
                                                <td><FontAwesomeIcon index={i} onClick={this.deleteRow}
                                                                     className={'hover align-middle'}
                                                                     icon={faTrashAlt} size={"1x"} id={'delete_' + i}/>
                                                </td>
                                            </tr>
                                        );
                                    }.bind(this)
                                )}
                                </tbody>
                            </table>
                        </div>
                        <div className={"col-6"}>
                            <table className={"table mb-0 caption-top customTable"}>
                                <tbody>
                                <tr>
                                    <th className={"align-middle"} style={{width: "15rem"}}>
                                        Anwendung hinzufügen:
                                    </th>
                                    <td>
                                        <Dropdown value={this.state.appSelect} itemID={"test"} inputId={"appText"}
                                                  style={{width: "10rem", fontSize: "small"}} className={"align-right"}
                                                  optionValue={"value"} optionLabel={"name"} options={this.apps}
                                                  onChange={(e) => {
                                                      this.onAppsChange(e)
                                                  }}/>
                                        <Button disabled={this.state.btnDisable} title={""} className={"align-right"}
                                                variant="outline-dark" style={{
                                            width: "4rem",
                                            marginTop: ".5rem",
                                            fontSize: "laerger",
                                            padding: "0",
                                            height: "33.8px"
                                        }} onClick={this.onAddClick}>+</Button>
                                        <input className={"form-control align-right"} type={"number"} name={"datarate"}
                                               id={"num"}
                                               defaultValue={1}
                                               min={"1"} max={"100"} step={"1"}
                                               onChange={this.onNumChange}
                                               style={{
                                                   width: "5.5rem",
                                                   marginTop: ".5rem",
                                                   marginRight: ".5rem",
                                                   fontSize: "small"
                                               }}/>

                                    </td>
                                </tr>
                                <tr>
                                    <th className={"align-middle"}>
                                        Datenrate [MBit/s]:
                                    </th>
                                    <td>
                                        <input className={"form-control align-right"} type={"number"} name={"datarate"}
                                               id={"datarate"} value={this.state.currentApp.datarate}
                                               disabled={this.state.currentApp.apps.length !== 0}
                                               onChange={(e) => {
                                                   let temp = {...this.state.currentApp}
                                                   temp.datarate = parseInt(e.target.value)
                                                   this.setState({currentApp: temp}, () => this.userChanged(e)
                                                   )
                                               }}
                                               min={"0"} max={String(this.maxDataRate)} step={"5"}
                                               style={{width: "10rem", fontSize: "small"}}/>
                                    </td>
                                </tr>
                                <tr>
                                    <th className={"align-middle"}>
                                        Übertragungsrichtung:
                                    </th>
                                    <td>
                                        <Dropdown value={this.state.currentApp.direction} inputId={"direction"}
                                                  style={{width: "10rem", fontSize: "small"}} className={"align-right"}
                                                  optionValue={"value"} optionLabel={"label"} options={this.direction}
                                                  onChange={(e) => {
                                                      this.onDirChange(e)
                                                  }} placeholder="Select a Direction"/>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </Dialog>
                <Dialog pt={{
                    closeButton: {
                        style: {display: "none"}
                    }
                }} header={
                    <div className="inline-flex align-items-center justify-content-center gap-2">
                        <span className="font-bold white-space-nowrap">Basisversorgung </span>
                    </div>
                } footer={
                    <div>
                        <Button className={"me-3"} label="Speichern" icon="pi pi-check" onClick={() => {
                            this.datarateChange()
                            this.setState({baseDialog: false})
                        }}
                                disabled={parseFloat(this.state.datarateDownLink) + parseFloat(this.state.datarateUpLink) === 0}>Speichern</Button>
                        <Button label="Abbrechen" icon="pi" onClick={() => {
                            this.setState({
                                baseDialog: false,
                                datarateDownLink: this.json.datarateDownLink,
                                datarateUpLink: this.json.datarateUpLink
                            })
                        }}>Abbrechen</Button>
                    </div>
                } visible={this.state.baseDialog} onHide={() => {
                    this.setState({baseDialog: false})
                }}>
                    <div className={""}>
                        <table className={"table mb-0 caption-top customTable"}>
                            <tbody>
                            <tr style={{border: "white"}}>
                                <td className="text-right">
                                    <div style={{display: "flex", alignItems: "center", marginBottom: "1rem"}}>
                                        <label htmlFor="datarateUplink"
                                               style={{width: "6rem", marginRight: "0.5rem"}}>Uplink:</label>
                                        <input className="form-control" type="number" name="datarateUplink"
                                               id="datarateUplink"
                                               value={this.state.datarateUpLink}
                                               min="0" max="1000" step="5"
                                               onChange={(e) => this.setState({datarateUpLink: e.target.value})}
                                               style={{width: "5rem", fontSize: "small"}}/>
                                        <span style={{marginLeft: "0.5rem"}}>MBit/s</span>
                                    </div>
                                    <div style={{display: "flex", alignItems: "center"}}>
                                        <label htmlFor="datarateDownLink"
                                               style={{width: "6rem", marginRight: "0.5rem"}}>Downlink:</label>
                                        <input className="form-control" type="number" name="datarateDownLink"
                                               id="datarateDownLink"
                                               value={this.state.datarateDownLink}
                                               min="0" max="1000" step="5"
                                               onChange={(e) => this.setState({datarateDownLink: e.target.value})}
                                               style={{width: "5rem", fontSize: "small"}}/>
                                        <span style={{marginLeft: "0.5rem"}}>MBit/s</span>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </Dialog>
            </div>
        )
    };
}

export default OutdoorTrafficModelSubmission;
